import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { handleApiExceptions, alertify, generate_query_set, printRupee } from '../../app_methods';
import { EaseTable } from '../../libs/EaseTable';
import { getVirtualAccountTransactionTableColumns, transactionFilterNodes } from './constants';
import { isMobile } from 'react-device-detect';
import { SmartCollectTransaction, VirtualAccount } from '../../models';
import TransactionDetailsDrawer from './transaction_details_drawer';
import { PermissionHoc } from '../HOC';
import { PaginationKaBaap, TransactionSearchModal } from '../Common';
import FileSaver from 'file-saver';
import { Badge, Descriptions } from 'antd';
import { SMART_COLLECT_TRANSACTIONS_STATUS_TYPES } from '../../constants';
import { EaseDrawer } from '../../libs/EaseDrawer';
import { Text4 } from '../../styles';

const VATransactions = (props) => {
    const filter_by = (props.match.params && props.match.params.filter_by) || null;
    let order_id = null;
    let virtual_account_id = null;
    let submerchant_id = null ;
    const [showTransactionSearchModal, setShowTransactionSearchModal] = React.useState(false);
    if (filter_by == "orders") {
        order_id = (props.match.params && props.match.params.id) || null;
        submerchant_id = (props.match.params && props.match.params.merchant_id) || null;
    } else if (filter_by == "virtual-accounts") {
        virtual_account_id = (props.match.params && props.match.params.id) || null;
        submerchant_id = (props.match.params && props.match.params.merchant_id) || null;
    }

    const toggleTransactionSearchModal = () => {
        setShowTransactionSearchModal(!showTransactionSearchModal)
    }
    const [isTableLoading, setIsTableLoading] = React.useState(false);
    const [activeTransaction, setActiveTransaction] = React.useState({});
    const [pagination, setPagination] = useState({
        pageSize: 15,
        current: 1,
        hasNext: true,
        showing: { from: 1, to: 15 }
    });
    const [filters, setFilters] = React.useState({});
    const [txns, setTxns] = React.useState([]);
    const [showDetailsDrawer, setShowDetailsDrawer] = React.useState(false);
    const [isDownloading, setIsDownloading] = React.useState(false);
    const [showStatusInfoDrawer, setShowStatusInfoDrawer] = React.useState(false);
    const [virtualAccounts, setVirtualAccounts] = React.useState([]);

    const toggleTransactionDetailsDrawer = (data = {}) => {
        setActiveTransaction(data);
        setShowDetailsDrawer(!showDetailsDrawer);
    }

    const prepFilters = (filters) => {
        let _filters = { ...filters };
        if (_filters.created_at && _filters.created_at.length) {
            _filters.created_at_start = _filters.created_at[0].format("YYYY-MM-DD");
            _filters.created_at_end = _filters.created_at[1].format("YYYY-MM-DD");
            delete _filters.created_at;
        }
        return _filters;
    };

    const fetchTransactions = async (_pagination=pagination, _filters=filters) => {
        if (!props.current_user.key) return;
        setIsTableLoading(true);
        const response = await SmartCollectTransaction.list_v2({ ...{ pageSize: _pagination.pageSize, current: _pagination.current }, ...prepFilters(_filters) });
        if (!response.success) {
            setIsTableLoading(false);
            handleApiExceptions(response);
            return;
        }
        let txns = generate_query_set(SmartCollectTransaction, response.data.results)
        txns = txns.map((account) => { return { ...account, is_submerchant:!!_filters.submerchant_id }})
        setTxns(txns);
        setPagination({ ..._pagination, ...response.data.pagination  });
        setIsTableLoading(false);
    };

    const downloadReport = async () => {
        setIsDownloading(true);
        const response = await SmartCollectTransaction.download_report({ ...prepFilters(filters) });
        if (response.status != 200) {
            setIsDownloading(false);
            handleApiExceptions("Something went wrong !");
            return;
        }
        FileSaver.saveAs(response.data, `Insta Collect Transactions.csv`);
        setIsDownloading(false);
    };

    const initActionButton = () => {
        const btn = props.actionRef.current;
        if (btn){
            const btnProps = { ...btn.props, onClick: () => toggleTransactionSearchModal() }
            btn.props = { ...btnProps };
        }
    }

    const tableColumns = getVirtualAccountTransactionTableColumns({ toggleTransactionDetailsDrawer:  toggleTransactionDetailsDrawer, setShowStatusInfoDrawer: setShowStatusInfoDrawer});

    const handleTableChange = (tableInfo) => {
        if (tableInfo.trigger == "columns") return;
        let _pagination = tableInfo.pagination;
        if (tableInfo.trigger == "filters") _pagination.current = 1;
        setPagination(_pagination);
        setFilters(tableInfo.filters);
        fetchTransactions(_pagination, tableInfo.filters);
    };
    const getVirtualAccounts = async (label) => {
        let response = null;
        if (label !='') {
            response = await VirtualAccount.listSearch({label: label});
        } else {
            response = await VirtualAccount.listSearch();
        }
        setVirtualAccounts(response?.data?.data);
    };
    const tableFilters = transactionFilterNodes({ virtual_account_id: virtual_account_id, order_id: order_id, submerchant_id: submerchant_id}, props.current_user, virtualAccounts, getVirtualAccounts );

    const fetchInitialVirtualAccounts = async () => {
        const response = await VirtualAccount.list();
        setVirtualAccounts(response?.data?.results);
    }

    const onPageChange = (_pagination) => {
        setPagination({ ..._pagination });
        fetchTransactions({ ..._pagination }, filters);
    };

    useEffect(() => {
        props.onTabRender('transactions');
        let _filters = { ...filters };
        let defaultFilters = {};
        tableFilters.forEach(f => defaultFilters[f.field] = f.defaultValue);
        _filters = { ..._filters, ...defaultFilters };
        setFilters({ ..._filters });
        fetchTransactions({ ...pagination }, { ..._filters });
        fetchInitialVirtualAccounts();
        setTimeout(() => {
            initActionButton();
        }, 1000);
    }, []);


    return (
        <div className="row">
            <div className="col-12">
                <EaseTable
                    rowKey="id"
                    loading={isTableLoading}
                    data={txns}
                    columns={tableColumns}
                    fixedSelectable={!isMobile}
                    handleTableChange={handleTableChange}
                    // pagination={pagination}
                    // totalRecords={pagination.total}
                    filterNodes={tableFilters}
                    downloadable={true}
                    onDownload={downloadReport}
                    isDownloading={isDownloading}
                /><PaginationKaBaap pageChange={onPageChange} pagination={pagination} />
            </div>
            <TransactionSearchModal
                visible={showTransactionSearchModal}
                toggleTransactionSearchModal={toggleTransactionSearchModal}
                merchantId={props.current_user.id}
            />
            <TransactionDetailsDrawer
                visible={showDetailsDrawer}
                onClose={toggleTransactionDetailsDrawer}
                transaction={activeTransaction}
                fetchTransactions={fetchTransactions}
            />
            <EaseDrawer
                visible={showStatusInfoDrawer}
                onClose={() => setShowStatusInfoDrawer(false)}
                hideFooter
                title="Transaction Statuses"
                width={500}
            >
                <Descriptions bordered className="mt-3" size="small" layout="horizontal" column={1}>
                    {
                        Object.keys(SMART_COLLECT_TRANSACTIONS_STATUS_TYPES).map((key, index) => {
                            return <Descriptions.Item label={<Badge color={SMART_COLLECT_TRANSACTIONS_STATUS_TYPES[key].color} text={<Text4>{SMART_COLLECT_TRANSACTIONS_STATUS_TYPES[key].label}</Text4>} />}>
                                {SMART_COLLECT_TRANSACTIONS_STATUS_TYPES[key].description}
                            </Descriptions.Item>
                        })
                    }
                </Descriptions>
            </EaseDrawer>
        </div>
    )
}

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
})

export default connect(mapStateToProps, null)(PermissionHoc(VATransactions, 'IC_CVA_TRANSACTIONS_READ'));
